import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';

import { SaveCompanyComplianceMutationVariables } from '../graphql/mutations/saveCompanyCompliance.gql';
import { GetCompanyComplianceDataQuery } from '../graphql/queries/getCompanyComplianceData.gql';

type ModuleData = GetCompanyComplianceDataQuery & {
  isMandatee: boolean;
};

const initialContext = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
} as { getModuleData: () => ModuleData };

const model = createModel(initialContext, {
  events: {
    ...baseEvents,
    SAVE_COMPANY_MEMBER_SANCTIONS: (
      data: Pick<
        SaveCompanyComplianceMutationVariables['input'],
        'hasClientUnderSanctions'
      >,
    ) => ({ data }),
    SAVE_COMPANY_SANCTIONS: (
      data: Pick<
        SaveCompanyComplianceMutationVariables['input'],
        | 'hasClientHelpingCountryUnderSanctions'
        | 'hasClientInCountryUnderSanctions'
      >,
    ) => ({ data }),
    SUBMIT_ACTIVITY_OUTSIDE_EU: (
      data: Pick<
        SaveCompanyComplianceMutationVariables['input'],
        'hasActivityOutsideEU'
      >,
    ) => ({ data }),
  },
});

export default model;

export type Context = typeof initialContext;
export type Model = typeof model;
